import { QueryClient, QueryKey } from '@tanstack/react-query';

import { DeepPartial } from '../../../types';
import { mergeDeep } from '../../../utils/objects';

export const updateQueryDataAtKey = <DataType extends Record<string, any>>(
  queryClient: QueryClient,
  key: QueryKey,
  newData: DeepPartial<DataType>,
) => {
  queryClient.setQueryData<DataType>(key, (existingData) => {
    if (!existingData) {
      return existingData;
    }

    return mergeDeep<DataType>(existingData, newData);
  });
};
